export const RequestTypes = Object.freeze({
	SELF: String('SELF'),
	SINGLE: String('SINGLE'),
	ANNUAL_REVIEW: String('ANNUAL_REVIEW'),
	NON_EMPLOYEE: String('NON_EMPLOYEE'),
	MULTI_USER: String('MULTI_USER'),
	MULTI_USER_NON_EMPLOYEE: String('MULTI_USER_NON_EMPLOYEE'),
	FOR_OTHERS_SERVICE_ACCOUNT: String('FOR_OTHERS_SERVICE_ACCOUNT'),
	SELF_SERVICE_ACCOUNT: String('SELF_SERVICE_ACCOUNT'),
	MULTI_SERVICE_ACCOUNT: String('MULTI_SERVICE_ACCOUNT'),
});
